module.exports = __webpack_public_path__ + "img/lg_ring_skip_0_null_0@3x.7757e60f.png";